import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-enviar-token',
  imports: [],
  templateUrl: './icon-enviar-token.component.html',
  styleUrl: './icon-enviar-token.component.css'
})
export class IconEnviarToken {
  @Input() color: string = '#171717';
  @Input() size: string = '24px';
}
